import { apiFetch, withQuery } from '@/lib/api/client';
import type { BoardColumnPage, ColumnFilter, TaskStatus } from '@/types/api';

/**
 * The board, one column at a time.
 *
 * Query building lives here rather than in the hook: the hook's job is caching, and a
 * URL assembled inside a queryFn is a request nobody can call from anywhere else.
 */
export interface BoardColumnRequest {
  readonly status: TaskStatus;
  readonly filter?: ColumnFilter | undefined;
  /** Opaque, from the previous page. Never constructed here. */
  readonly cursor?: string | null | undefined;
  /** Admin only — narrows the board to one person. */
  readonly assigneeId?: string | undefined;
}

export function fetchBoardColumn({
  status,
  filter,
  cursor,
  assigneeId,
}: BoardColumnRequest): Promise<BoardColumnPage> {
  return apiFetch<BoardColumnPage>(
    withQuery(`/board/columns/${status}`, {
      cursor,
      assigneeId,
      priority: filter?.priority,
      tag: filter?.tag,
      overdue: filter?.overdue ? 'true' : undefined,
    }),
  );
}
